<div class='app-content' [ngClass]='isMobile ? "mobile" : "pc"' *ngIf='incentiveDetail'>
  <div class='app-header'>
    <div class='title-bg'></div>
    <h2 class='title-text'>
      <span>{{currRuleTitle}}</span>
    </h2>
    <div class='title-icon'></div>
  </div>
  <div class='app-body'>
    <span class='item-name' *ngIf='info?.BRAND_NAME?.value || info?.STORE_NAME?.value'>
      <span *ngIf='info?.BRAND_NAME?.value'>{{ info?.BRAND_NAME?.value }}</span>
      <span *ngIf='info?.STORE_NAME?.value'>{{ info?.STORE_NAME?.value }}</span>
    </span>
    <div class='item-desc'>
      <span class='prod-info' [ngClass]='{"link" : !isMobile}' (click)='itemLinkClick(info.URL.value + "")'>{{info?.SKU_NAME?.value}}</span>
      <div class='prod-info' *ngIf='isMobile && currRule?.ruleKey === ictRuleKey.TSI_SALES'>
        {{ prodInfo }}
      </div>
    </div>
    <div class='item-kpis'>
      <div class='kpis-wrapper'>
        <ng-container *ngFor='let kpi of calcKpis'>
          <div>
            <span class='kpi-icon'></span>
            <span>{{info[kpi]?.dictKeyName![currLang]}}: </span>
            <span>
            <ng-container [ngSwitch]='info[kpi]?.dataType'>
              <ng-container *ngSwitchCase='valueType.Decimal'>￥{{info[kpi]?.value | number:'1.0-0'}}</ng-container>
              <ng-container *ngSwitchCase='valueType.Percent'>{{info[kpi]?.value | percent:'1.2-2'}}</ng-container>
              <ng-container *ngSwitchDefault>{{info[kpi]?.value}}</ng-container>
            </ng-container>
          </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
  <div class='app-footer'>
    <div class='wrapper'>
      <div class='qrcode'>
        <!--<ngx-qrcode
          [elementType]='elementType'
          [errorCorrectionLevel]='correctionLevel'
          [value]='qrUrl'
          [width]='101' [margin]='1'>
        </ngx-qrcode>-->
        <qrcode
          [qrdata]="qrUrl"
          [elementType]="elementType"
          [allowEmptyString]="true"
          [errorCorrectionLevel]="correctionLevel"
          [margin]="2"
          [scale]="1"
          [style.width.px]="102"
        ></qrcode>
      </div>
      <div>扫描二维码，{{ isMobile ? "申请MyEcom试用账号" : "分享给朋友"}}</div>
      <div *ngIf='isMobile'>您可以通过手机分享到朋友圈或者您的朋友</div>
    </div>
  </div>
  <div>
    <h5 class='sec-tip'>
      本页面仅限平台分析,不得对外披露<br/>
      <span class='sec-tip link value-tip' nz-tooltip [nzTooltipTitle]="dataCalcTooltip" [nzTooltipTrigger]='"click"' nzTooltipOverlayClassName='data-tooltip-panel'><u>数据说明</u></span>
      数据来源于尼尔森IQ数据平台监测.
    </h5>
    <ng-template #dataCalcTooltip>
      <nz-table nzTemplateMode nzSize='small'>
        <thead>
        <tr><th>数据说明</th><th></th></tr>
        </thead>
        <tbody>
        <tr><td>当月销售额</td><td>/</td></tr>
        <tr><td>折后销售额</td><td>/</td></tr>
        <tr><td>折扣比例</td><td>折后销售额/当月销售额</td></tr>
        <tr><td>平均价格</td><td>销售额/销售件数</td></tr>
        <tr><td>品类平均价格</td><td>本品类销售额/本品类销售件数</td></tr>
        <tr><td>平均价格/品类平均价格指数</td><td>平均价格/品类平均价格</td></tr>
        <tr><td>参与直播商品占比</td><td>参与直播商品数量/商品总数量</td></tr>
        <tr><td>参与直播商品平均销售额</td><td>参与直播商品销售额/参与直播商品数量</td></tr>
        </tbody>
      </nz-table>
    </ng-template>
  </div>
</div>
